export const propertyValueAliases = new Map([
	[
		"General_Category",
		new Map([
			["C", "Other"],
			["Cc", "Control"],
			["cntrl", "Control"],
			["Cf", "Format"],
			["Cn", "Unassigned"],
			["Co", "Private_Use"],
			["Cs", "Surrogate"],
			["L", "Letter"],
			["LC", "Cased_Letter"],
			["Ll", "Lowercase_Letter"],
			["Lm", "Modifier_Letter"],
			["Lo", "Other_Letter"],
			["Lt", "Titlecase_Letter"],
			["Lu", "Uppercase_Letter"],
			["M", "Mark"],
			["Combining_Mark", "Mark"],
			["Mc", "Spacing_Mark"],
			["Me", "Enclosing_Mark"],
			["Mn", "Nonspacing_Mark"],
			["N", "Number"],
			["Nd", "Decimal_Number"],
			["digit", "Decimal_Number"],
			["Nl", "Letter_Number"],
			["No", "Other_Number"],
			["P", "Punctuation"],
			["punct", "Punctuation"],
			["Pc", "Connector_Punctuation"],
			["Pd", "Dash_Punctuation"],
			["Pe", "Close_Punctuation"],
			["Pf", "Final_Punctuation"],
			["Pi", "Initial_Punctuation"],
			["Po", "Other_Punctuation"],
			["Ps", "Open_Punctuation"],
			["S", "Symbol"],
			["Sc", "Currency_Symbol"],
			["Sk", "Modifier_Symbol"],
			["Sm", "Math_Symbol"],
			["So", "Other_Symbol"],
			["Z", "Separator"],
			["Zl", "Line_Separator"],
			["Zp", "Paragraph_Separator"],
			["Zs", "Space_Separator"]
		])
	],
	[
		"Script",
		new Map([
			["Adlm", "Adlam"],
			["Aghb", "Caucasian_Albanian"],
			["Ahom", "Ahom"],
			["Arab", "Arabic"],
			["Armi", "Imperial_Aramaic"],
			["Armn", "Armenian"],
			["Avst", "Avestan"],
			["Bali", "Balinese"],
			["Bamu", "Bamum"],
			["Bass", "Bassa_Vah"],
			["Batk", "Batak"],
			["Beng", "Bengali"],
			["Bhks", "Bhaiksuki"],
			["Bopo", "Bopomofo"],
			["Brah", "Brahmi"],
			["Brai", "Braille"],
			["Bugi", "Buginese"],
			["Buhd", "Buhid"],
			["Cakm", "Chakma"],
			["Cans", "Canadian_Aboriginal"],
			["Cari", "Carian"],
			["Cham", "Cham"],
			["Cher", "Cherokee"],
			["Copt", "Coptic"],
			["Qaac", "Coptic"],
			["Cprt", "Cypriot"],
			["Cyrl", "Cyrillic"],
			["Deva", "Devanagari"],
			["Dogr", "Dogra"],
			["Dsrt", "Deseret"],
			["Dupl", "Duployan"],
			["Egyp", "Egyptian_Hieroglyphs"],
			["Elba", "Elbasan"],
			["Elym", "Elymaic"],
			["Ethi", "Ethiopic"],
			["Geor", "Georgian"],
			["Glag", "Glagolitic"],
			["Gong", "Gunjala_Gondi"],
			["Gonm", "Masaram_Gondi"],
			["Goth", "Gothic"],
			["Gran", "Grantha"],
			["Grek", "Greek"],
			["Gujr", "Gujarati"],
			["Guru", "Gurmukhi"],
			["Hang", "Hangul"],
			["Hani", "Han"],
			["Hano", "Hanunoo"],
			["Hatr", "Hatran"],
			["Hebr", "Hebrew"],
			["Hira", "Hiragana"],
			["Hluw", "Anatolian_Hieroglyphs"],
			["Hmng", "Pahawh_Hmong"],
			["Hmnp", "Nyiakeng_Puachue_Hmong"],
			["Hrkt", "Katakana_Or_Hiragana"],
			["Hung", "Old_Hungarian"],
			["Ital", "Old_Italic"],
			["Java", "Javanese"],
			["Kali", "Kayah_Li"],
			["Kana", "Katakana"],
			["Khar", "Kharoshthi"],
			["Khmr", "Khmer"],
			["Khoj", "Khojki"],
			["Knda", "Kannada"],
			["Kthi", "Kaithi"],
			["Lana", "Tai_Tham"],
			["Laoo", "Lao"],
			["Latn", "Latin"],
			["Lepc", "Lepcha"],
			["Limb", "Limbu"],
			["Lina", "Linear_A"],
			["Linb", "Linear_B"],
			["Lisu", "Lisu"],
			["Lyci", "Lycian"],
			["Lydi", "Lydian"],
			["Mahj", "Mahajani"],
			["Maka", "Makasar"],
			["Mand", "Mandaic"],
			["Mani", "Manichaean"],
			["Marc", "Marchen"],
			["Medf", "Medefaidrin"],
			["Mend", "Mende_Kikakui"],
			["Merc", "Meroitic_Cursive"],
			["Mero", "Meroitic_Hieroglyphs"],
			["Mlym", "Malayalam"],
			["Modi", "Modi"],
			["Mong", "Mongolian"],
			["Mroo", "Mro"],
			["Mtei", "Meetei_Mayek"],
			["Mult", "Multani"],
			["Mymr", "Myanmar"],
			["Nand", "Nandinagari"],
			["Narb", "Old_North_Arabian"],
			["Nbat", "Nabataean"],
			["Newa", "Newa"],
			["Nkoo", "Nko"],
			["Nshu", "Nushu"],
			["Ogam", "Ogham"],
			["Olck", "Ol_Chiki"],
			["Orkh", "Old_Turkic"],
			["Orya", "Oriya"],
			["Osge", "Osage"],
			["Osma", "Osmanya"],
			["Palm", "Palmyrene"],
			["Pauc", "Pau_Cin_Hau"],
			["Perm", "Old_Permic"],
			["Phag", "Phags_Pa"],
			["Phli", "Inscriptional_Pahlavi"],
			["Phlp", "Psalter_Pahlavi"],
			["Phnx", "Phoenician"],
			["Plrd", "Miao"],
			["Prti", "Inscriptional_Parthian"],
			["Rjng", "Rejang"],
			["Rohg", "Hanifi_Rohingya"],
			["Runr", "Runic"],
			["Samr", "Samaritan"],
			["Sarb", "Old_South_Arabian"],
			["Saur", "Saurashtra"],
			["Sgnw", "SignWriting"],
			["Shaw", "Shavian"],
			["Shrd", "Sharada"],
			["Sidd", "Siddham"],
			["Sind", "Khudawadi"],
			["Sinh", "Sinhala"],
			["Sogd", "Sogdian"],
			["Sogo", "Old_Sogdian"],
			["Sora", "Sora_Sompeng"],
			["Soyo", "Soyombo"],
			["Sund", "Sundanese"],
			["Sylo", "Syloti_Nagri"],
			["Syrc", "Syriac"],
			["Tagb", "Tagbanwa"],
			["Takr", "Takri"],
			["Tale", "Tai_Le"],
			["Talu", "New_Tai_Lue"],
			["Taml", "Tamil"],
			["Tang", "Tangut"],
			["Tavt", "Tai_Viet"],
			["Telu", "Telugu"],
			["Tfng", "Tifinagh"],
			["Tglg", "Tagalog"],
			["Thaa", "Thaana"],
			["Thai", "Thai"],
			["Tibt", "Tibetan"],
			["Tirh", "Tirhuta"],
			["Ugar", "Ugaritic"],
			["Vaii", "Vai"],
			["Wara", "Warang_Citi"],
			["Wcho", "Wancho"],
			["Xpeo", "Old_Persian"],
			["Xsux", "Cuneiform"],
			["Yiii", "Yi"],
			["Zanb", "Zanabazar_Square"],
			["Zinh", "Inherited"],
			["Qaai", "Inherited"],
			["Zyyy", "Common"],
			["Zzzz", "Unknown"]
		])
	],
	[
		"Script_Extensions",
		new Map([
			["Adlm", "Adlam"],
			["Aghb", "Caucasian_Albanian"],
			["Ahom", "Ahom"],
			["Arab", "Arabic"],
			["Armi", "Imperial_Aramaic"],
			["Armn", "Armenian"],
			["Avst", "Avestan"],
			["Bali", "Balinese"],
			["Bamu", "Bamum"],
			["Bass", "Bassa_Vah"],
			["Batk", "Batak"],
			["Beng", "Bengali"],
			["Bhks", "Bhaiksuki"],
			["Bopo", "Bopomofo"],
			["Brah", "Brahmi"],
			["Brai", "Braille"],
			["Bugi", "Buginese"],
			["Buhd", "Buhid"],
			["Cakm", "Chakma"],
			["Cans", "Canadian_Aboriginal"],
			["Cari", "Carian"],
			["Cham", "Cham"],
			["Cher", "Cherokee"],
			["Copt", "Coptic"],
			["Qaac", "Coptic"],
			["Cprt", "Cypriot"],
			["Cyrl", "Cyrillic"],
			["Deva", "Devanagari"],
			["Dogr", "Dogra"],
			["Dsrt", "Deseret"],
			["Dupl", "Duployan"],
			["Egyp", "Egyptian_Hieroglyphs"],
			["Elba", "Elbasan"],
			["Elym", "Elymaic"],
			["Ethi", "Ethiopic"],
			["Geor", "Georgian"],
			["Glag", "Glagolitic"],
			["Gong", "Gunjala_Gondi"],
			["Gonm", "Masaram_Gondi"],
			["Goth", "Gothic"],
			["Gran", "Grantha"],
			["Grek", "Greek"],
			["Gujr", "Gujarati"],
			["Guru", "Gurmukhi"],
			["Hang", "Hangul"],
			["Hani", "Han"],
			["Hano", "Hanunoo"],
			["Hatr", "Hatran"],
			["Hebr", "Hebrew"],
			["Hira", "Hiragana"],
			["Hluw", "Anatolian_Hieroglyphs"],
			["Hmng", "Pahawh_Hmong"],
			["Hmnp", "Nyiakeng_Puachue_Hmong"],
			["Hrkt", "Katakana_Or_Hiragana"],
			["Hung", "Old_Hungarian"],
			["Ital", "Old_Italic"],
			["Java", "Javanese"],
			["Kali", "Kayah_Li"],
			["Kana", "Katakana"],
			["Khar", "Kharoshthi"],
			["Khmr", "Khmer"],
			["Khoj", "Khojki"],
			["Knda", "Kannada"],
			["Kthi", "Kaithi"],
			["Lana", "Tai_Tham"],
			["Laoo", "Lao"],
			["Latn", "Latin"],
			["Lepc", "Lepcha"],
			["Limb", "Limbu"],
			["Lina", "Linear_A"],
			["Linb", "Linear_B"],
			["Lisu", "Lisu"],
			["Lyci", "Lycian"],
			["Lydi", "Lydian"],
			["Mahj", "Mahajani"],
			["Maka", "Makasar"],
			["Mand", "Mandaic"],
			["Mani", "Manichaean"],
			["Marc", "Marchen"],
			["Medf", "Medefaidrin"],
			["Mend", "Mende_Kikakui"],
			["Merc", "Meroitic_Cursive"],
			["Mero", "Meroitic_Hieroglyphs"],
			["Mlym", "Malayalam"],
			["Modi", "Modi"],
			["Mong", "Mongolian"],
			["Mroo", "Mro"],
			["Mtei", "Meetei_Mayek"],
			["Mult", "Multani"],
			["Mymr", "Myanmar"],
			["Nand", "Nandinagari"],
			["Narb", "Old_North_Arabian"],
			["Nbat", "Nabataean"],
			["Newa", "Newa"],
			["Nkoo", "Nko"],
			["Nshu", "Nushu"],
			["Ogam", "Ogham"],
			["Olck", "Ol_Chiki"],
			["Orkh", "Old_Turkic"],
			["Orya", "Oriya"],
			["Osge", "Osage"],
			["Osma", "Osmanya"],
			["Palm", "Palmyrene"],
			["Pauc", "Pau_Cin_Hau"],
			["Perm", "Old_Permic"],
			["Phag", "Phags_Pa"],
			["Phli", "Inscriptional_Pahlavi"],
			["Phlp", "Psalter_Pahlavi"],
			["Phnx", "Phoenician"],
			["Plrd", "Miao"],
			["Prti", "Inscriptional_Parthian"],
			["Rjng", "Rejang"],
			["Rohg", "Hanifi_Rohingya"],
			["Runr", "Runic"],
			["Samr", "Samaritan"],
			["Sarb", "Old_South_Arabian"],
			["Saur", "Saurashtra"],
			["Sgnw", "SignWriting"],
			["Shaw", "Shavian"],
			["Shrd", "Sharada"],
			["Sidd", "Siddham"],
			["Sind", "Khudawadi"],
			["Sinh", "Sinhala"],
			["Sogd", "Sogdian"],
			["Sogo", "Old_Sogdian"],
			["Sora", "Sora_Sompeng"],
			["Soyo", "Soyombo"],
			["Sund", "Sundanese"],
			["Sylo", "Syloti_Nagri"],
			["Syrc", "Syriac"],
			["Tagb", "Tagbanwa"],
			["Takr", "Takri"],
			["Tale", "Tai_Le"],
			["Talu", "New_Tai_Lue"],
			["Taml", "Tamil"],
			["Tang", "Tangut"],
			["Tavt", "Tai_Viet"],
			["Telu", "Telugu"],
			["Tfng", "Tifinagh"],
			["Tglg", "Tagalog"],
			["Thaa", "Thaana"],
			["Thai", "Thai"],
			["Tibt", "Tibetan"],
			["Tirh", "Tirhuta"],
			["Ugar", "Ugaritic"],
			["Vaii", "Vai"],
			["Wara", "Warang_Citi"],
			["Wcho", "Wancho"],
			["Xpeo", "Old_Persian"],
			["Xsux", "Cuneiform"],
			["Yiii", "Yi"],
			["Zanb", "Zanabazar_Square"],
			["Zinh", "Inherited"],
			["Qaai", "Inherited"],
			["Zyyy", "Common"],
			["Zzzz", "Unknown"]
		])
	]
]);
